/* DOWB Impulsive — sticky "Add to cart" bar (source: #clarke-sticky-atc).
   Shows once the real add-to-cart button has scrolled out of view; clicking it clicks the real
   submit button so the cart drawer app (or Dawn's drawer) handles the add exactly as normal. */
(function () {
  function init() {
    var bar = document.querySelector('.cj-sticky-atc');
    if (!bar || bar.dataset.cjInit) return;
    bar.dataset.cjInit = '1';
    var btn = bar.querySelector('button');
    var mobileOnly = bar.dataset.desktop !== 'true';
    var scrollTrigger = parseInt(bar.dataset.scroll || '0', 10);
    function realButton() {
      return document.querySelector('product-form form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] button[name="add"], .product-form__submit');
    }
    function sync() {
      var real = realButton();
      if (!real) return;
      btn.disabled = real.disabled || real.getAttribute('aria-disabled') === 'true';
      var span = real.querySelector('span');
      if (span && bar.dataset.mirror === 'true') btn.textContent = span.textContent.trim();
    }
    function update() {
      var real = realButton();
      if (!real) return;
      if (mobileOnly && window.innerWidth > 600) { bar.classList.remove('is-visible'); return; }
      var r = real.getBoundingClientRect();
      // source behaviour (measured 1440 + 390): the bar appears once the top of the real button has scrolled past
      // the top of the viewport, i.e. just after the button disappeared under the sticky header
      var passed = r.top < 0;
      var scrolled = window.scrollY > scrollTrigger;
      var show = scrollTrigger > 0 ? scrolled : passed;
      bar.classList.toggle('is-visible', show);
      sync();
    }
    btn.addEventListener('click', function () {
      var real = realButton();
      if (real && !real.disabled) real.click();
    });
    var ticking = false;
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { update(); ticking = false; }); } }, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('change', sync);
    update();
    // rating link: smooth scroll to the reviews anchor without changing the URL hash
    document.querySelectorAll('.cj-pdp-rating__link').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var dest = id && document.getElementById(id);
        if (dest) { e.preventDefault(); dest.scrollIntoView({ behavior: 'smooth' }); }
      });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
